import { State } from '../../store';
import { createSelector, MemoizedSelector } from '@ngrx/store';
import { selectState } from './pathways-state.selector';
import { selectSelectedTreatmentActivityId } from '@ispm-client/modules/process-executor';
import { isEmpty } from 'lodash';

const getBpmnNodesCurationData = (state: State): any => state.bpmnNodesCurationData;

export const selectBpmnNodesCurationData: MemoizedSelector<
  object,
  any
  > = createSelector(selectState, getBpmnNodesCurationData);

export const selectSelectedTreatmentsNodeData = createSelector([
  selectBpmnNodesCurationData,
  selectSelectedTreatmentActivityId],
(nodes, id) => {
    if (isEmpty(nodes) || !id) {
      return null;
    }
    const curationData = nodes[id];
    return curationData.data;
  }
);

export const selectTreatmentNodeDataById = (id: string) =>
 createSelector(selectBpmnNodesCurationData, (nodes) => !isEmpty(nodes) && id && nodes[id]);

export const selectSelectedTreatmentPlanNote = createSelector(
  selectSelectedTreatmentsNodeData,
  (data) => data ? data.note : null
);

export const selectSelectedTreatmentPlan = createSelector(
  selectSelectedTreatmentsNodeData,
  (data) => data ? data.treatmentPlans : null
);
